/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rename_Description_AddInputs */

const en_rename_description_add = /** @type {(inputs: Rename_Description_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add a description`)
};

const de_rename_description_add = /** @type {(inputs: Rename_Description_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beschreibung hinzufügen`)
};

/**
* | output |
* | --- |
* | "Add a description" |
*
* @param {Rename_Description_AddInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const rename_description_add = /** @type {((inputs?: Rename_Description_AddInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rename_Description_AddInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_rename_description_add(inputs)
	return en_rename_description_add(inputs)
});